import React from 'react';
import Loading from 'components/Loading';
import './_support.scss';
import Flex from 'ui/Flex/Flex';
import ClientsGridContainer from './ClientsGrid/ClientsGridContainer';
import { useGetClients } from '../hooks/getClients';
import SupportHeader from './SupportHeader/SupportHeader';

function Support(): React.ReactElement {
    const { data: binds, isLoading } = useGetClients();

    if (isLoading || !binds) {
        return <Loading />;
    }

    // FIXME remove the nex components when all code is there
    return (
        <Flex className="page-container" direction="column">
            <SupportHeader bind={undefined} />
            <ClientsGridContainer clients={binds} />
        </Flex>
    );
}

export default Support;
